<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
      <h2>Change Password</h2>
      <div class="flex-container gap-2">
        <div class="dialog-btn" (click)="onClose()">
          <img class="dialog-close-btn" src="../../../assets/images/close.png" alt="close">
        </div>
      </div>
    </div>
    <form #f="ngForm" name="form" (ngSubmit)="onSubmit(f)" novalidate>
      <div class="dialog-content-block p-3">
        <div class="gap-5 w-100 mt-4">
          <div class="flex-column">
            <!-- <div class="form-group">
              <h6 class="text-start text-dark">Current Password</h6>
              <input type="password" name="currentPassword" [(ngModel)]="currentPassword" required>
              <div class="form-error-msg"></div>
            </div> -->
            <div class="form-group">
              <h6 class="text-start text-dark">New Password</h6>
              <input type="password" name="newPassword" [(ngModel)]="newPassword" required>
              <div class="form-error-msg"></div>
            </div>
          </div>
          <div class="flex-column">
            <div class="form-group">
              <h6 class="text-start text-dark">Confirm New Password</h6>
              <input type="password" name="confirmNewPassword" [(ngModel)]="confirmNewPassword" required>
              <div class="form-error-msg"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <button type="button" (click)="onClose()">Cancel</button>
        <button type="submit" class="update" (click)="onSubmit(f)">Update</button>
      </div>
    </form>
  </div>
  